export default __webpack_public_path__ + "static/media/speciality_id_2.5aca4c3d.png";